<!-- <p>please-wait-dialog works!</p> -->
<div>
  <h2 matDialogTitle>Please wait!</h2>
  <mat-dialog-content>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</div>
